export const PA_VOTE_COPY = {
  info: 'Please allocate 10 points across the options below',
  overallocation: (overPoint: number) =>
    `You have used ${overPoint} too many points`,
  remaining: 'points remaining',
  exactPoint: 'You have used up all your points',
};
